// Helpers d'affichage (euros, kilometrages) en francais.

const euros = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
const entiers = new Intl.NumberFormat("fr-FR");

export function formaterEuros(valeur) {
  return euros.format(Number(valeur || 0));
}

/**
 * Nombre decimal a la francaise : virgule, pas point.
 *
 * Sans cela, la meme fiche affichait « 5 326,00 EUR » et « 0.178 EUR/km » cote
 * a cote. Le melange fait amateur, et sur un chiffre financier il fait douter
 * du reste.
 */
export function formaterDecimal(valeur, decimales = 2) {
  if (valeur === null || valeur === undefined || valeur === "") return "—";
  return Number(valeur).toLocaleString("fr-FR", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  });
}

/** Une periode dont le debut est APRES la fin (audit B3, 28/09/2026).
 *
 * Elle ne contient aucun jour : le serveur renvoyait donc des totaux a zero,
 * et l'ecran affichait « 0,00 € » -- une flotte sans depense, la ou il n'y
 * avait qu'une saisie a l'envers. Les ecrans ne chargent rien et le DISENT ; le
 * serveur refuse aussi (422, `routes/commun._filtrer_intervalle`). Dates ISO :
 * la comparaison de chaines suit l'ordre des jours. */
export function periodeInversee(debut, fin) {
  return Boolean(debut && fin && debut > fin);
}

export const MESSAGE_PERIODE_INVERSEE =
  "La date de début est après la date de fin : aucune période à afficher.";

export function formaterKm(valeur) {
  if (valeur === null || valeur === undefined || valeur === "") return "—";
  return entiers.format(Number(valeur)) + " km";
}

// Date ISO (AAAA-MM-JJ, avec ou sans heure) -> JJ/MM/AAAA, sans conversion de
// fuseau. Date nulle/invalide -> "—" (jamais "Invalid Date").
export function formaterDate(valeur) {
  if (!valeur) return "—";
  const iso = String(valeur).slice(0, 10); // ignore une eventuelle partie horaire
  const parts = iso.split("-");
  if (parts.length !== 3) return "—";
  const [annee, mois, jour] = parts;
  return `${jour}/${mois}/${annee}`;
}

// Ajoute n mois a une date, en restant dans le mois vise : le 31/01 + 1 mois
// donne le 28/02 (ou le 29), jamais le 03/03 que rendrait `setMonth`.
function plusMois(date, n) {
  const cible = new Date(date.getFullYear(), date.getMonth() + n, 1);
  const dernierJour = new Date(cible.getFullYear(), cible.getMonth() + 1, 0).getDate();
  cible.setDate(Math.min(date.getDate(), dernierJour));
  return cible;
}

// L'ecart entre aujourd'hui et une date ISO, en MOIS ET JOURS de calendrier :
// « 2 mois et 3 j », « 1 an et 8 mois », « 12 j ». Un compte en jours seuls (« dans
// 609 j ») oblige a diviser de tete ; demande de Yanis le 05/10/2026.
// Les mois se comptent sur le calendrier, pas par tranches de 30 jours : du
// 05/10 au 05/12, c'est « 2 mois », pas « 2 mois et 1 j ».
// Rend { texte, passe } ; null si la date manque ou ne se lit pas.
export function ecartMoisJours(valeurIso, aujourdhui = new Date()) {
  if (!valeurIso) return null;
  const [a, m, j] = String(valeurIso).slice(0, 10).split("-").map(Number);
  if (!a || !m || !j) return null;
  const cible = new Date(a, m - 1, j);
  const jour = new Date(aujourdhui.getFullYear(), aujourdhui.getMonth(), aujourdhui.getDate());
  const passe = cible < jour;
  const [debut, fin] = passe ? [cible, jour] : [jour, cible];

  let mois = (fin.getFullYear() - debut.getFullYear()) * 12 + (fin.getMonth() - debut.getMonth());
  if (plusMois(debut, mois) > fin) mois -= 1;
  // Math.round absorbe l'heure d'ete : un jour de 23 h reste un jour.
  const jours = Math.round((fin - plusMois(debut, mois)) / 86400000);

  // Au-dela d'un an, les annees : « 46 mois » se divise encore de tete
  // (choix de Yanis le 05/10 : « 3 ans et 10 mois »).
  const ans = Math.floor(mois / 12);
  const resteMois = mois % 12;
  const morceaux = [];
  if (ans > 0) morceaux.push(`${ans} an${ans > 1 ? "s" : ""}`);
  if (resteMois > 0) morceaux.push(`${resteMois} mois`);
  if (jours > 0 || mois === 0) morceaux.push(`${jours} j`);
  const dernier = morceaux.pop();
  const texte = morceaux.length ? `${morceaux.join(", ")} et ${dernier}` : dernier;
  return { texte, passe };
}
